<template>
  <div class="tab_wrap">
<!--    <span class="line"></span>-->
    <ul>
        <li  v-for="(item, index) in navArr" :key="index" @click="tabClick(index)">
            <div :class="{'active' : navIndex == index}">
                {{item}}
            </div>
<!--            <span class="line">-->
<!--            </span>-->
        </li>
    </ul>
<!--    <span class="line">-->
<!--    </span>-->
  </div>
</template>
<script>

export default {
  name:"",    
  data: () => ({
    navArr: [],
    navIndex: 0,
  }),
  props: [
      'tabArr',
      'parNavIndex'
  ],
  watch: {
    tabArr(res){
        this.navArr = res;
    },
    setNavIndex:{
        handler(newVal, oldVal){
            this.navIndex = newVal;
            this.navIndex = newVal;
        },
        immediate: true,
        deep: true,
    }
  },
  components: {

  },
  created() {

  },
  mounted() {
    this.navArr = this.tabArr;
  },
  computed: {
    setNavIndex(){
        return this.parNavIndex;
    }
  },
  methods: {
      tabClick(index){
          this.navIndex = index;
          this.$emit('index', index);
      }
  }
}
</script>
<style lang="scss" scoped>
.tab_wrap{
    display: flex;
    align-items: flex-end;
    span.line{
        display: inline-block;
        height: 1px;
        background: #00EEF3;
    }
    span.line:first-child{
        width: 10px;
    }
    ul{
        font-size: 0;
        li{
            display: inline-block;
            font-size: 0;
            div{
                display: inline-block;
                vertical-align: bottom;
                font-size: 16px;
                width: 60px;
                height: 41px;
                text-align: center;
                line-height: 40px;
                box-sizing: border-box;
                border-radius: 5px 5px 0 0;
                cursor: pointer;
                color: #74D9FF;
                &.active{
                    position: relative;
                    border-bottom: 4px solid #74d9ff;
                    /*&:after{*/
                    /*  content: "";*/
                    /*  display: block;*/
                    /*  position: absolute;*/
                    /*  width: 30px;*/
                    /*  right: 6px;*/
                    /*  bottom: 9px;*/
                    /*  border-bottom: 4px solid #74d9ff;*/
                    /*}*/
                }
            }
            span{
                width: 10px;
                vertical-align: bottom;
            }
        }
    }
    span.line:last-child{
        flex-grow: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layer/tab-nav.vue